<template>
  <div class="content__column content__column--small">
    <h1 class="content__title">Información de la Categoría</h1>
    <div class="information" v-if="category">
      <p v-if="category.title_es" class="information__text">
        <strong class="information__text--strong">Nombre: </strong
        >{{ category.title_es }}
      </p>
      <p v-if="category.parent_id" class="information__text">
        <strong class="information__text--strong">Categoría Superior: </strong
        ><span v-text="category.sub_title_es"></span>
      </p>
    </div>
  </div>
</template>

<script>
import { category_status } from "./mocks";
export default {
  props: {
    category: {
      type: Object
    }
  },
  computed: {
    status: function() {
      let status = category_status.filter(
        element => element.id === this.page.status_id
      );
      return status[0].name;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/product_categories/view.vue